export const FILTER_SIDEBAR_SIZE = {
  OPEN: 85,
  CLOSE: 15,
} as const

export const COLLECTIONS_DISPLAY_SIZES = {
  LARGE: '390px',
  SMALL: '257px',
} as const

export const STATUS_FILTERS = {
  BUY_NOW: 'Buy Now',
  ON_AUCTION: 'On Auction',
  NEW: 'New',
  HAS_OFFERS: 'Has Offers',
} as const

export const CURRENCIES = {
  DOLLAR: 'United States Dollar (USD)',
  ETHER: 'Ether (ETH)',
} as const
